import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import i18next from 'i18next';
import useTypedSelector from 'hooks/useTypedSelector';

import { onChangePassword } from 'redux/actions/auth.actions';
import ChangePasswordView from 'views/public/ChangePasswordView';
import LayoutContainer from 'containers/LayoutContainer';

const ChangePasswordContainer: React.FC = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { loading, message } = useTypedSelector((state) => state.auth);

  const query = new URLSearchParams(location.search);
  const token = query.get('token');
  const email = query.get('email');

  const handlePasswordChange = (password: string) => {
    if (token && email) {
      dispatch(onChangePassword({ token, email, password }));
    }
  };

  return (
    <LayoutContainer isPublic title={i18next.t('CHANGE_PASSWORD:TITLE', 'Restablecer Contraseña')}>
      <ChangePasswordView
        onSubmit={handlePasswordChange}
        loading={loading}
        message={message ?? null}
        hasParams={!!(token && email)}
      />
    </LayoutContainer>
  );
};

export default ChangePasswordContainer;
